import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FolderIcon from '@mui/icons-material/FolderOutlined';
import { Alert, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

export interface Props {
  lockGroupName: string;
  onClick?: () => void;
  onDeleteClickIcon?: () => void;
  numberOfSelectedDoors?: number;
  id: string;
  deleteIconId?: string;
}

type WhiteSpace = 'nowrap';
const TruncatedTypography = styled(Typography)(() => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap' as WhiteSpace,
  textOverflow: 'ellipsis',
  maxWidth: '17rem'
}));

const LockGroup: React.FC<React.PropsWithChildren<Props>> = ({
  lockGroupName,
  numberOfSelectedDoors,
  id,
  deleteIconId,
  onClick,
  onDeleteClickIcon
}) => {
  const theme = useTheme();

  const handleWrapperOnClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    if (onClick !== undefined) onClick();
  };

  const handleIconOnClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    if (onDeleteClickIcon !== undefined) onDeleteClickIcon();
  };

  if (numberOfSelectedDoors !== 0)
    return (
      <Alert
        id={id}
        onClick={(event) => handleWrapperOnClick(event)}
        severity="error"
        icon={<FolderIcon sx={{ color: theme.palette.text.primary }} />}
        variant="standard"
        sx={{
          position: 'relative',
          '&:hover .icon': {
            opacity: '1 !important'
          },
          backgroundColor: 'rgba(99, 102, 111, 0.08)',
          border: '1px solid #444',
          cursor: 'pointer'
        }}
        action={
          <IconButton
            id={deleteIconId}
            className="icon"
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => handleIconOnClick(event)}
            style={{
              position: 'absolute',
              color: theme.palette.text.primary,
              right: 16,
              opacity: 0,
              transition: 'opacity 0.3s ease'
            }}
          >
            <DeleteIcon />
          </IconButton>
        }
      >
        <Tooltip title={lockGroupName} arrow>
          <TruncatedTypography variant="body1" style={{ color: theme.palette.text.primary }}>
            {`${lockGroupName} (${numberOfSelectedDoors})`}
          </TruncatedTypography>
        </Tooltip>
      </Alert>
    );
  return (
    <Alert
      id={id}
      severity="error"
      onClick={(event) => handleWrapperOnClick(event)}
      icon={<FolderIcon sx={{ color: 'rgba(255, 152, 0, 1)' }} />}
      variant="standard"
      sx={{
        backgroundColor: 'rgba(237, 108, 2, 0.08)',
        border: '1px solid rgba(237, 108, 2, 0.5)',
        position: 'relative',
        '&:hover .icon': {
          opacity: '1 !important'
        }
      }}
      action={
        <IconButton
          id={deleteIconId}
          className="icon"
          aria-label="close"
          color="inherit"
          size="small"
          onClick={(event) => handleIconOnClick(event)}
          style={{
            position: 'absolute',
            color: theme.palette.text.primary,
            right: 16,
            opacity: 0,
            transition: 'opacity 0.3s ease'
          }}
        >
          <DeleteIcon />
        </IconButton>
      }
    >
      <Tooltip title={lockGroupName} arrow>
        <TruncatedTypography variant="body1" style={{ color: '#FF9800' }}>
          {`${lockGroupName} (${numberOfSelectedDoors})`}
        </TruncatedTypography>
      </Tooltip>
    </Alert>
  );
};

export default LockGroup;
